import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen w-full bg-forest-800 text-cream-300 antialiased selection:bg-gold-500 selection:text-forest-900" data-id="element-0">
      <LandingPage data-id="element-1" />
    </div>;
}